// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PreviewContent-module-previewContent-2U4WA{position:relative}.PreviewContent-module-previewContent-2U4WA::before{content:\"\";position:absolute;top:0;inset-inline-start:0;width:100%;height:100%;background:linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 100%);opacity:5;z-index:1}", ""]);
// Exports
exports.locals = {
	"previewContent": "PreviewContent-module-previewContent-2U4WA"
};
module.exports = exports;
